export const initEvents  = {
        onSetDomain: function () { console.log("onSetDomain"); },
        onChangeStatus: function () { console.log("onChangeStatus"); },
        onAgentInfo: function () { console.log("onAgentInfo"); },
        onChangePassword: function () { console.log("onChangePassword"); },
        onValidatingTelephony : function () { console.log("onValidatingTelephony"); },
        onReceivedCamps: function () { console.log("onReceivedCamps"); },
        onReceivedUnavailables: function () { console.log("getUnavailables"); },
        onCallReceived: function () { console.log("onCallReceived"); },
        onCallEnds: function () { console.log("onCallEnds"); },
        onUpdateData: function () { console.log("onUpdateData"); },
        onDialResult: function () { console.log("onDialResult"); },
        onCancelScheduledManualCall : function () { console.log("onCancelScheduledManualCall"); },
        onChangeVolume: function () { console.log("onChangeVolume"); },
        onMute: function () { console.log("onMute"); },
        onHoldCall: function () { console.log("onHoldCall"); },
        onStopStartRecording: function () { console.log("onStopStartRecording"); },
        onQueueCall: function () { console.log("onQueueCall"); },
        onReceivedDispositions: function () { console.log("getDispositions"); },
        onReceivedDispositionsAndNumbers: function () {console.log("getDispositionsAndNumbers"); },
        onReceivedGetPhoneNumbers: function () {console.log("getPhoneNumbers"); },
        onReceivedCallsToday: function () {console.log("getCallsToday");},
        onReceivedUnavailablesHistory: function () {console.log("getUnavailablesHistory");},
        onReceivedXferOptions: function () { console.log("onReceiveXferOptions"); },
        onSecondCallConnected: function () { console.log("onSecondCallConnected"); },
        onSecondCall: function () { console.log("onSecondCall"); },
        onSecondCallHangUp: function () { console.log("onSecondCallHangUp"); },    
        onCallbacksToDial: function () { console.log("getCallbacks"); },
        onCallbacksPerCampaign: function () { console.log("getCallbacks"); },
        onConnectionReconnected: function () { console.log("rabbit-reconnected"); },
        onListAdminsToChat: function () {console.log("getAdminsToChat")},
        onChatMessages: function () {console.log("getChats")},
        onIVRList: function () {console.log("getIVRList")},
        onConferenceCallConnected : function () {console.log("onConferenceCallConnected")},
        onConferenceCallHangUp : function () {console.log("onConferenceCallHangUp")},
        onConferenceNewSecondCallSet : function () {console.log("onConferenceNewSecondCallSet")},
        onIddleEnd: function () {console.log("onIddleEnd")},
	onLastCallDataInbound: function () {console.log("getLastCallDataInbound")},
        onLastCallDataOutbound: function () {console.log("getLastCallDataOutbound")},
	onTransferUnavailableAgent: function () {console.log("onTransferUnavailableAgent")},
        onToolsTransferOptions: function () {console.log("toolsTransfersOptions");},
}
